module.exports = __webpack_public_path__ + "newgdc-191b1c44.webp";